import React from 'react';
import { sanitizeSchoolNoticeHtml } from '../../utils/schoolNoticeHtml';

interface SignUpLegalDetailModalProps {
  title: string;
  /** 관리자 에디터 HTML */
  bodyHtml: string;
  /** 내용 없을 때 표시 */
  emptyFallback: string;
  onCancel: () => void;
  /** 동의 후 닫기 */
  onConfirm: () => void;
}

const SignUpLegalDetailModal: React.FC<SignUpLegalDetailModalProps> = ({
  title,
  bodyHtml,
  emptyFallback,
  onCancel,
  onConfirm,
}) => {
  const safe = sanitizeSchoolNoticeHtml(bodyHtml);
  const inner =
    safe.trim().length > 0 ? (
      <div className="cp-auth-legal-modal-html cp-school-notice-html" dangerouslySetInnerHTML={{ __html: safe }} />
    ) : (
      <p className="cp-auth-legal-modal-empty">{emptyFallback}</p>
    );

  return (
    <div
      className="cp-modal-backdrop cp-auth-modal-backdrop cp-auth-modal-backdrop--front"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cp-signup-legal-detail-title"
      onClick={onCancel}
    >
      <div
        className="cp-modal cp-auth-modal cp-auth-modal--legal-wide cp-auth-modal--legal-detail"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="cp-signup-legal-detail-title" className="cp-auth-modal-title">
          {title}
        </h2>
        <div className="cp-auth-legal-modal-scroll" tabIndex={0}>
          {inner}
        </div>
        <div className="cp-modal-footer cp-leave-modal-actions">
          <button type="button" className="cp-btn-secondary" onClick={onCancel}>
            취소
          </button>
          <button type="button" className="cp-btn-primary" onClick={onConfirm}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignUpLegalDetailModal;
